<template>
  <div class="PAGINATION">
    <router-link
        :to="to(currentPage-1)"
        :class="{ 'DISABLED': currentPage === 1 }"
        class="LINK"
        selenium="page-prev-link-active">
      <vk-icon name="chevronleft" class="text-sm"/>
    </router-link>

    <router-link
        v-for="(n,index) in visiblePageNumbers"
        :key="index"
        :class="{ 'CURRENT': currentPage === n }"
        :to="to(n)"
        :selenium="`page-link:${n}`"
        class="LINK">
      {{ n }}
    </router-link>

    <router-link
        :to="to(currentPage+1)"
        :class="{ 'DISABLED': currentPage >= totalPageCount }"
        class="LINK"
        selenium="page-next-link-active">
      <vk-icon name="chevronright" class="text-sm"/>
    </router-link>

  </div>
</template>

<script>
import _clamp from 'lodash/clamp';
import _range from 'lodash/range';

export default {
  name: 'page-pagination',
  props: {
    totalItemCount: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    visiblePageCount: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    currentPage () {
      return ((this.$route.query.from / this.pageSize) + 1) || 1;
    },
    totalPageCount () {
      return Math.ceil(this.totalItemCount / this.pageSize);
    },
    visiblePageNumbers () {
      const frameRadius = Math.floor(this.visiblePageCount / 2);
      const firstFrameCenter = this.visiblePageCount - frameRadius;
      const lastFrameCenter = this.totalPageCount - frameRadius;
      const center = _clamp(this.currentPage, firstFrameCenter, lastFrameCenter);
      const first = center - frameRadius;
      return _range(first, first + Math.min(this.visiblePageCount, this.totalPageCount));
    },
  },
  methods: {
    to (currentPage) {
      if (currentPage < 1 || currentPage > this.totalPageCount) {
        return this.$route.fullPath;
      }
      return {
        query: {
          ...this.$route.query,
          size: this.pageSize,
          from: ((currentPage - 1) * this.pageSize),
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  $border: 1px solid $color-gray40;

  .PAGINATION {
    @include text-medium;
    display: inline-flex;
    align-items: center;
    border-left: $border;
    background-color: $color-gray10;
  }

  .LINK {
    @include square(36px);
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    border: $border;
    border-left-style: none;
    color: $color-depot;
    text-decoration: none;

    &.CURRENT {
      background-color: $color-gray40;
      border: $color-gray90;
      color: $color-gray80;
      cursor: default;
    }

    &.DISABLED {
      cursor: not-allowed;
      color: $color-gray40;
    }
  }
</style>
